import React, { useEffect, useState } from "react";
import Modal from "react-responsive-modal";
import { useForm } from "react-hook-form";
import LoadMask from "../../../../../../../Utils/LoadMask/LoadMask";
import { getErrorFromResponse } from "../../../../../../../../../utility/utils";
import { PESO_KG_PACA_PRODUCCION } from "../../../../../../../../../utility/constants";
import { NumberField } from "../../../../../../../Utils/renderField/fieldsHookForms";

export const EdicionKgForm = (props) => {
    const { ordenEdicion, onClose, ActualizarKgOrdenProduccion } = props;

    const {
        control: formControl,
        register: formRegister,
        setValue: formSetValue,
        getValues: formGetValues,
        trigger: validateForm,
        watch: formWatch,
        formState: { errors: formErrors },
    } = useForm({
        mode: "onChange",
        defaultValues: {
            pacas_secadora: { value: false, label: "No" },
        },
    });

    useEffect(() => {
        if (ordenEdicion) {
            formSetValue("kg_a_producir", ordenEdicion.kg_a_producir || 0);
        } else {
            formSetValue("kg_a_producir", "");
        }
    }, [ordenEdicion]);

    const [cargando, setCargando] = useState(false);

    const GuardarCambios = async () => {
        try {
            setCargando(true);
            const isValid = await validateForm();
            if (!isValid) return;
            const kgAProducir = formGetValues("kg_a_producir");

            await ActualizarKgOrdenProduccion(ordenEdicion.id, kgAProducir);
            onClose();
        } catch (error) {
            console.log(
                "Error al actualizar kg de la orden de producción:",
                error,
            );
        } finally {
            setCargando(false);
        }
    };

    return (
        <Modal
            open={!!ordenEdicion}
            onClose={onClose}
            focusTrapped={false}
            styles={{
                modal: {
                    maxWidth: "500px",
                    width: "50%",
                },
            }}
        >
            <LoadMask loading={cargando} blur>
                <h5 className="text-center mb-2">Actualizar kg a producir</h5>

                <div className="formulario-fields-column gap-1rem">
                    <div className="formulario-field">
                        <label>Kg a producir</label>
                        <NumberField
                            control={formControl}
                            name="kg_a_producir"
                            errors={formErrors}
                            allowNegative={false}
                            suffix=" Kg"
                            rules={{
                                required: "Este campo es obligatorio",
                                min: {
                                    value: 1,
                                    message: "Debe ser al menos 1",
                                },
                            }}
                            decimalScale={2}
                        />
                    </div>
                </div>

                <div className="d-flex flex-wrap justify-content-center mt-4 mb-2 gap-1rem">
                    <button className="btn btn-outline-dark" onClick={onClose}>
                        Regresar
                    </button>
                    <button
                        className="btn btn-primary"
                        onClick={GuardarCambios}
                    >
                        Guardar
                    </button>
                </div>
            </LoadMask>
        </Modal>
    );
};
